import { useContext } from 'react';
import { SmartFillModalContext } from './context';
import { useCRMSearch } from '../../../CRMSearchProvider/useCRMSearch';
import { useSmartFillCalculations } from '../../useSmartFillCalculations';
export function useSmartFillModal() {
  const machine = useContext(SmartFillModalContext);
  const {
    total: crmSearchTotal
  } = useCRMSearch();
  if (!machine) {
    throw new Error('useSmartFillModal must be used within SmartFillModalContextProvider');
  }
  const {
    state,
    send
  } = machine;
  const {
    fillOption: currentFillOption,
    selectedProperties,
    selectionMethod,
    selectionIds,
    smartProperty,
    totalWithEmptyProperties
  } = state.context;
  const onSetFillOption = fillOption => send({
    type: 'SET_FILL_OPTIONS',
    data: {
      fillOption
    }
  });
  const onEnrich = () => send({
    type: 'ENRICH'
  });
  const actualRecordCount = selectionMethod === 'BY_QUERY' ? crmSearchTotal : selectionIds.length;
  const {
    recordsToFill,
    estimatedTotal
  } = useSmartFillCalculations({
    fillOption: currentFillOption,
    selectedProperties,
    selectionMethod,
    totalRecordCount: actualRecordCount,
    totalWithEmptyProperties
  });
  return {
    estimatedTotal,
    fillOption: state.context.fillOption,
    isLoading: state.hasTag('loading'),
    onEnrich,
    onSetFillOption,
    recordsToFill,
    smartProperty,
    total: estimatedTotal
  };
}